import packageJson from '../../package.json';

export const environment = {
  appVersion: packageJson.version,
  production: true,
  URL: 'https://teste.segurosvirtual.pt/api/v1',
  URLROBOT: 'https://teste.segurosvirtual.pt/apirobot/v1',
  chatbotUrl: '/webhook/api',
  URLSite: 'https://teste.segurosvirtual.pt',
  uploadFoldertmp: '/var/www/segurosvirtual/Documentos',
  uploadFolder: '/var/www/segurosvirtual/Documentos',
  maxAllowedSize: 10 * 1024 * 1024,
  maxImageAllowedSize: 1 * 1024 * 1024,
  maxAllowedfiles: 40,
  maxAllowedSizeClaims: 10 * 1024 * 1024,
  maxAllowedfilesClaims: 10,
  maxAllowedfilessafesimulations: 15,
  encryptionKey: '',
  facebookPixelId: '1068810562044559',
  googleClientId: '212196689979-8k9guhk3d89lkmr1mjff1tm4odmmu162.apps.googleusercontent.com',

  // 🔐 API Security
  apiKey: 'SV_55C572CB722CC296AC7DA63F0F981CC41FA1838CA6F3FB01682AE0280EB289B6',

  // ⚙️ HOMEPAGE CONFIGURATION
  features: {
    skipAuthInDev: false,
    showLogs: false,
  },
};
